import { useState, useEffect } from 'react';

interface Breakpoint {
  isMobile: boolean;   // < 768px
  isTablet: boolean;   // 768px - 1024px
  isDesktop: boolean;  // > 1024px
}

export function useBreakpoint(): Breakpoint {
  const getBreakpoint = (): Breakpoint => {
    const width = window.innerWidth;
    return {
      isMobile: width < 768,
      isTablet: width >= 768 && width < 1024,
      isDesktop: width >= 1024,
    };
  };

  const [bp, setBp] = useState<Breakpoint>(getBreakpoint);

  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}
